"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var $radioInput = jQuery('.inputs__option');
    var imageChange = function () {
        jQuery('.radioImage').fadeOut();
        jQuery('.radiobtn').hide();
        jQuery('.inputs__text').removeClass('hiw-look-active-text');
        jQuery('.image-content').find("[data-index='".concat(jQuery(this).data('index'), "']")).fadeIn();
        jQuery('.buttons-container').find("[data-index='".concat(jQuery(this).data('index'), "']")).fadeIn();
        jQuery(this).siblings('.inputs__text').addClass('hiw-look-active-text');
    };
    $radioInput.on('click', imageChange);
};
exports.init = init;
